import { render, staticRenderFns } from "./HelpShopFovorite.vue?vue&type=template&id=175c64c6&"
import script from "./HelpShopFovorite.vue?vue&type=script&lang=js&"
export * from "./HelpShopFovorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports